var $wishlistButton = $('#ProductSection-product-template-default .groups-btn .wishlist-btn');
var $wishlistTile = $('.wishlist-tile-container');
var $wishlistItemCount = $('.wishlistCount');
var numProductTiles = $wishlistTile.length;
var wishlist = localStorage.getItem('user_wishlist') || [];
if (wishlist.length > 0) {
  wishlist = JSON.parse(localStorage.getItem('wishlist'));
}

var getItemFromStorage = function () {
  var storage = window.localStorage.getItem('wishlist', null);
  if (storage !== null || storage !== 'undefined') {
    return JSON.parse(storage);
  }

  return null;
}

var saveItemFromStorage = function (item) {

  var storage = getItemFromStorage();
  if (storage !== null) {
    storage.push(item);
  } else {
    storage = [item];
  }

  window.localStorage.setItem('wishlist', JSON.stringify(storage));
}

/* Add item to wishlist array */
var wishlistProductItem = function (self) {

  $wishlistButton.on('click',function(e){

    var $this = $(this);
    $this.addClass('disabled');
    toggleLoader();

    e.preventDefault();
    var form = $(this).closest('form');
    var productInfo = null;
    var product = form.serializeArray();
    var wishlist = [];

    if (product && product.length > 0 && product[0].name === 'product') {
      var productUrl = product[1].value;
      var product = JSON.parse(product[0].value)
      var size = 1

      if (product.variants && product.variants.length !== 1) {
      	size = product.variants.length
      }

      productInfo = {
        id: product.variants[0].id,
        title: product.title,
        url: productUrl,
        price: product.price,
        featured_image: product.featured_image,
        price: product.price,
        size: product.variants.length
      }

      saveItemFromStorage(productInfo);
      
      // update badge of wishlist counts
	  updateWishlistItemCount();
      toggleLoader();
    }

  });
};

/*
   * Update button to show current state (gold for active)
   */   
var animateWishlist = function (self) {
  $(self).toggleClass('is-active');
};

/*
   * Add/Remove selected item to the user's wishlist array in localStorage
   * Wishlist button class 'is-active' determines whether or not to add or remove
   * If 'is-active', remove the item, otherwise add it
   */   
var removeItemFromWishlist = function (removeIndex) {
  var wishlist = getItemFromStorage();

  wishlist.splice(removeIndex, 1);  
  localStorage.setItem('wishlist', JSON.stringify(wishlist));
  
  // update badge of wishlist counts
  updateWishlistItemCount();
};

/*
   * Loop through wishlist buttons and activate any items that are already in user's wishlist
   * Activate by adding class 'is-active'
   * Run on initialization
   */   
var activateItemsInWishlist = function () {
  $wishlistButton.each(function () {
    var productHandle = $(this).attr('data-product-handle');
    if (wishlist.indexOf(productHandle) > -1) {
      $(this).addClass('is-active');
    }
  });
};

/*
   * Loop through product titles and remove any that aren't a part of the wishlist
   * Decrement numProductTiles on removal
   */   
var displayOnlyWishlistItems = function () {
  var wishlist = getItemFromStorage();
  if (wishlist) {
    return wishlist;
  }

  return [];
};

/*
   * Check if on the wishlist page and hide any items that aren't a part of the wishlist
   * If no wishlist items exist, show the empty wishlist notice
   */   
var loadWishlist = function () {
  if (window.location.href.indexOf('pages/wish-list') > -1) {
    displayOnlyWishlistItems();
  }
};
/**
     * Display number of items in the wishlist
     * Must set the $wishlistItemCount variable
     */
  var updateWishlistItemCount = function () {
    var wishlist = getItemFromStorage();
    if (wishlist) {
      $wishlistItemCount.text(wishlist.length);
    }
  };

var bindUIActions = function () {
  $wishlistButton.click(function (e) {
    e.preventDefault();
    updateWishlist(this);
    animateWishlist(this);
  });
};

(function () {
  	wishlistProductItem();
  	updateWishlistItemCount();
})();

